import React from 'react';
import { Badge } from './Badge';
import { RatingStars } from './RatingStars';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './Table';
import type { EventStatus, ExpertEvent } from '../types/expert';
import { formatAED, formatDate } from '../utils/expert';
type EventsTableProps = {
  events: ExpertEvent[];
};
const statusStyle: Record<EventStatus, string> = {
  Paid: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  Pending: 'border-amber-200 bg-amber-50 text-amber-700',
  Upcoming: 'border-sky-200 bg-sky-50 text-sky-700'
};
export function EventsTable({
  events
}: EventsTableProps) {
  const sorted = [...events].sort((a, b) => b.date.localeCompare(a.date));
  return <div className="overflow-hidden rounded-xl border" data-id="element-235" data-mp="1htf9nsjmg190">
      <Table data-id="element-236" data-mp="384timi229dej">
        <TableHeader data-id="element-237" data-mp="384a2n6vz0z35">
          <TableRow className="bg-muted/40" data-id="element-238" data-mp="385uxkxm76k1j">
            <TableHead data-id="element-239" data-mp="382yzn9acnvd3">Event</TableHead>
            <TableHead data-id="element-240" data-mp="3c6om9t7gs2vh">Role</TableHead>
            <TableHead data-id="element-241" data-mp="3c5ltffqkzqcx">Date</TableHead>
            <TableHead data-id="element-242" data-mp="31ojhdqumhlrx">Feedback</TableHead>
            <TableHead className="text-right" data-id="element-243" data-mp="31ni0v6uu872t">Fee</TableHead>
            <TableHead className="text-right" data-id="element-244" data-mp="2wq9jv9lfe935">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody data-id="element-245" data-mp="3bf5nmugg8zxy">
          {sorted.map(e => <TableRow key={e.id} data-id="element-246" data-mp="3bgp52odudh1b">
              <TableCell data-id="element-247" data-mp="36ft007hr7oub">
                <p className="font-medium" data-id="element-248" data-mp="36gko6x90ukak">{e.name}</p>
                <p className="text-xs text-muted-foreground" data-id="element-249" data-mp="2ipys84cakqgx">{e.organizer} · {e.location}</p>
              </TableCell>
              <TableCell className="text-muted-foreground" data-id="element-250" data-mp="2drdqg0he5yqd">{e.role}</TableCell>
              <TableCell className="whitespace-nowrap tabular-nums" data-id="element-251" data-mp="2so4rsfamlkim">{formatDate(e.date)}</TableCell>
              <TableCell data-id="element-252" data-mp="2np1kspb35480">
                {e.rating ? <RatingStars value={e.rating} size={12} data-id="element-253" data-mp="2no08yim8wdp8" /> : <span className="text-xs text-muted-foreground" data-id="element-254" data-mp="2nr4mw7piint3">—</span>}
              </TableCell>
              <TableCell className="text-right font-medium tabular-nums" data-id="element-255" data-mp="8008nv7z3npd">{formatAED(e.fee)}</TableCell>
              <TableCell className="text-right" data-id="element-256" data-mp="315gi2o48msl">
                <Badge variant="outline" className={statusStyle[e.status]} data-id="element-257" data-mp="a0za1fzg3xoj">{e.status}</Badge>
              </TableCell>
            </TableRow>)}
        </TableBody>
      </Table>
    </div>;
}